import { useEffect } from "react";
import HeaderStyleTwo from "../Shared/HeaderStyleTwo";
import Footer from "../Shared/Footer";
import VolunteersBanner from "../Shared/VolunteersBanner";
import Facts from "../Shared/Facts";
const FounderMessage = () => {
    useEffect(() => {
        runJQueryScripts();
    }, []);

    const runJQueryScripts = () => {
        let tag: any;
        let loadScript = function (src: string) {
            tag = document.createElement("script");
            tag.async = false;
            tag.src = src;
            document.getElementsByTagName("body")[0].appendChild(tag);
        };
        loadScript("../assets/js/jquery.js");
        loadScript("../assets/js/popper.min.js");
        loadScript("../assets/js/jquery-ui.js");
        loadScript("../assets/js/jquery.fancybox.js");
        loadScript("../assets/js/owl.js");
        loadScript("../assets/js/appear.js");
        loadScript("../assets/js/wow.js");
        loadScript("../assets/js/lazyload.js");
        loadScript("../assets/js/scrollbar.js");
        loadScript("../assets/js/script.js");
        return () => {
            document.getElementsByTagName("body")[0].removeChild(tag);
        }
    }
    return (
        <>
            <HeaderStyleTwo />
            {/* <section className="page-banner">
                <div className="image-layer lazy-image" data-bg="url('assets/images/background/bg-banner-1.jpg')"></div>
                <div className="bottom-rotten-curve alternate"></div>
                <div className="auto-container">
                    <h1>About Us</h1>
                    <ul className="bread-crumb clearfix">
                        <li><a href="/">Home</a></li>
                        <li className="active">About Us</li>
                    </ul>
                </div>
            </section> */}
            <div className="ulockd-inner-page">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="ulockd-icd-layer">
                                <ul className="list-inline ulockd-icd-sub-menu">
                                    <li><a style={{ color: '#25283a' }} href="/"> Home </a></li>
                                    <li><a style={{ color: '#25283a' }} href="#"> / </a></li>
                                    <li> <a href="/founder-message">Founder Message </a> </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="sidebar-page-container" style={{ padding: '50px 0px 0px' }}>
                <div className="auto-container">
                    <div className="row clearfix">
                        <div className="sidebar-side col-lg-4 col-md-12 col-sm-12">
                            <aside className="sidebar" style={{ padding: 0 }}>



                                <div className="image-box">
                                    <figure className="image" ><img className="lazy-image" style={{ borderTopLeftRadius: 20, borderTopRightRadius: 20 }} src="assets/images/resource/image-spacer-for-validation.png" data-src="assets/images/resource/dr-shoaib-siddiqu-founder-sadqa-e-jariya-welfare-foundation.jpg" alt="" /></figure>
                                </div>
                                <div className="sidebar-widget" style={{ padding: 20 }}>
                                    <h3 style={{ fontSize: 20, marginBottom: 10 }}> Dr. Shoaib A Siddiqui</h3>
                                    {/* <h4>
                                        <i style={{color:'#014278'}} className="flaticon-phone-call"></i> 
                                    (850) 42-SADQA(72372)
                                    </h4> */}
                                    <h3 style={{ fontSize: 20, marginBottom: 10 }}>
                                        {/* <i style={{color:'#014278'}} className="flaticon-location"></i>  */}
                                        10407 Emerald Woods Orlando, FL 32836</h3>

                                </div>

                            </aside>
                        </div>
                        <div className="content-side col-lg-8 col-md-12 col-sm-12">

                            <div className="blog-posts">
                                <div className="row clearfix">

                                    <div className="news-block col-lg-12 col-md-12 col-sm-12">
                                        <div className="inner-box">

                                            <div className="lower-content" style={{ padding: 20 }}>
                                                {/* <h3>As-salamu Alaykum (Greetings of peace)</h3> */}
                                                <p><b>As-salamu Alaykum (Greetings of peace)</b></p>
                                                <div className="text-content">
                                                    <p>
                                                        My name is Shoaib Anwer Siddiqui. With great humility, I would like to share with you the blessings that Allah Subhanaha Wa Tala has bestowed upon me.
                                                    </p>
                                                    <p>
                                                        I was born in Karachi, Pakistan to a Sunni Muslim family. My beloved parents, Anwer Zaman Siddiqui and Mahjabeen Anwer, and my grand parents (May Allah grant them high status in Jannah) guided me to the path that I am following.
                                                    </p>
                                                    <p>
                                                        I became a doctor in 1985 and was married in 1988 to my wife, a graceful soul, and also a doctor; we are blessed with 4 kids.
                                                    </p>
                                                    <p>
                                                        I moved to the USA and completed my residency with specialization in infectious disease and established a practice in Orlando, Florida. By the guidance of Allah (swt), I was able to be involved with the establishment of:
                                                    </p>
                                                    <ul>
                                                        <li>
                                                            {/* <i className="fa fa-star" style={{color:'#014278'}} aria-hidden="true"></i>  */}
                                                            Quran Explorer</li>
                                                        <li>
                                                            {/* <i className="fa fa-star" style={{color:'#014278'}} aria-hidden="true"></i>  */}
                                                            Darul Hfiz Orlando</li>

                                                        <li>
                                                            {/* <i className="fa fa-star" style={{color:'#014278'}} aria-hidden="true"></i>  */}
                                                            Muslim Academy of Greater Orlando / Islamic School</li>

                                                        <li>
                                                            {/* <i className="fa fa-star" style={{color:'#014278'}} aria-hidden="true"></i>  */}
                                                            American Muslim Youth Leadership Council</li>

                                                    </ul>
                                                    <br />
                                                    <p>
                                                        And Alhamdullilah, Sadqa-E-Jariya welfare foundation in Pakistan with the goal to support the orphans and widows as well as the less fortunate. I am thankful to my cousin and associate Omer Wajahat as well as my friend and software engineer Saquib Altaf, both who helped me establish this work for the sake of Allah. I pray to Almighty Allah to accept and give Barakah in this effort.
                                                    </p>
                                                    <p>
                                                        I would like to usher humble words of thanks to my Allah Who has guided me through this path. I would also like to offer special gratitude to my family for all their support.
                                                    </p>
                                                    <p>
                                                        In the end, I pray to Allah for continued guidance and allowing others to be part of this project to support the less fortunate which InshaAllah will lead to their own success in this world and the hereafter, Ameen.
                                                    </p>
                                                    <iframe width="100%" height="450" src="https://www.youtube.com/embed/w-XkZ3TUpwk?rel=0" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                                                </div>

                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            {/* <VolunteersBanner /> */}
            <Footer />
        </>
    );
};
export default FounderMessage;
